import * as React from 'react';
import MediaQuery from 'react-responsive';
import { IResponsive } from 'elc-layouts';

export const Mobile = ({ children, maxWidth }: IResponsive) => (
    <MediaQuery maxWidth={maxWidth} children={children} />
);

export const Desktop = ({ children, minWidth }: IResponsive) => (
    <MediaQuery minWidth={minWidth} children={children} />
);
